export const primaryColor = "#f8d247";
export const secondaryColor = "#000000";
